import { render, staticRenderFns } from "./WhiteItem.vue?vue&type=template&id=73e2acfe&scoped=true"
import script from "./WhiteItem.vue?vue&type=script&lang=js"
export * from "./WhiteItem.vue?vue&type=script&lang=js"
import style0 from "./WhiteItem.vue?vue&type=style&index=0&id=73e2acfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e2acfe",
  null
  
)

export default component.exports